import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { CustomFields, Lci3DimensionTableData } from '@features/lci-report';
import { DEFAULT_SLIDE_MASTER, Slide } from '@features/powerpoint';
import { visitAttributionDimensionsSlide } from '../../../visit-attribution/visit-attribution-dimensions-slide';
import { renderTableWithSubdimensions } from '../components/render-table';
import { UseCalculatedFieldsReturn } from '@features/campaigns';

const SUBDIMENSIONS_PER_SLIDE = 8;

export const visitAttributionTableSlides = (
  overall: Lci3Report['visitMetrics'],
  dimensionTableData: Lci3DimensionTableData,
  customFields: CustomFields,
  calculatedFields: UseCalculatedFieldsReturn['data']
): Slide[] =>
  renderTableWithSubdimensions(
    dimensionTableData,
    SUBDIMENSIONS_PER_SLIDE,
    ({ subdimensions, dimensionName, dimensionSlug, page, totalPages }) => {
      const customField =
        customFields.dimensions[
          dimensionSlug as keyof CustomFields['dimensions']
        ];

      const slideHeader =
        customField && customField.visitsTableHeader.length > 0
          ? customField.visitsTableHeader
          : `Visit Attribution Summary Table - By ${dimensionName} (${page}/${totalPages})`;

      return visitAttributionDimensionsSlide({
        slideMaster: DEFAULT_SLIDE_MASTER,
        overallVisitMetrics: overall,
        subdimensions,
        slideHeader,
        calculatedFields,
      });
    }
  );
